import React, {FC} from 'react';
import {connect} from 'react-redux';

import {DataEventTrackingProvider} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingProvider';
import {ResolveDispatchProps} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {LightUserThemeProvider} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getFirstTeamUserIsAdminOf} from '../../../../store/data/teams/teamsSelectors';
import {useOnboardingModalState} from '../../../app/topBar/onboarding/onboardingContext';
import {OnboardingGuidesEnum} from '../../guide/onboardingGuideTypes';
import {WorkflowsGuidePopover} from './workflowsGuidePopover';

/*
 * Props.
 */

interface WorkflowsGuidePopoverContainerProps {}

type WorkflowsGuidePopoverContainerComponentProps = WorkflowsGuidePopoverContainerProps &
  ResolveDispatchProps<typeof mapDispatchToProps>;

/*
 * Component.
 */

const WorkflowsGuidePopoverContainerComponent: FC<WorkflowsGuidePopoverContainerComponentProps> = () => {
  const {renderOnboardingGuideTransition, setOnboardingGuide, onboardingGuide} = useOnboardingModalState();
  const firstTeam = useAppSelector(getFirstTeamUserIsAdminOf);

  if (!firstTeam) {
    return null;
  }

  return renderOnboardingGuideTransition(OnboardingGuidesEnum.WORKFLOWS, (styles) => (
    <LightUserThemeProvider>
      <DataEventTrackingProvider context={{name: 'getting_started', payload: {}}}>
        <WorkflowsGuidePopover
          team={firstTeam}
          styles={styles}
          isWorkflowsGuideOpen={onboardingGuide === OnboardingGuidesEnum.WORKFLOWS}
          onClose={() => {
            setOnboardingGuide(undefined);
          }}
        />
      </DataEventTrackingProvider>
    </LightUserThemeProvider>
  ));
};

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({}));

export const WorkflowsGuidePopoverContainer = connect(
  null,
  mapDispatchToProps,
)(WorkflowsGuidePopoverContainerComponent);
